module.exports = __webpack_public_path__ + "img/setting.839715a.png";